import {useCallback, useMemo} from "react";
import {useFilterPrefix} from "./Filters/FilterPrefixProvider";
import {useSearchParams} from "react-router-dom";
import { SorterResult, SortOrder } from "antd/lib/table/interface";
import { ColumnsType } from "antd/lib/table";
import { Model } from "../../types";

export const useOrdering = <T,>(columns: ColumnsType<T>) => {
    const filterPrefix = useFilterPrefix();
    const [searchParams, setSearchParams] = useSearchParams();

    // Sync Table UI with the query
    const columnsWithOrder: ColumnsType<T> = useMemo(() => {
        const param = `${filterPrefix}.ordering`;
        let orderField: null | string = null;
        let orderDirection: null | SortOrder = null;

        if (searchParams.has(param)) {
            const ordering = searchParams.get(param)!; 
            if (ordering?.startsWith('-')) {
                [orderField, orderDirection] = [ordering.slice(1), 'descend'];
            } else {
                [orderField, orderDirection] = [ordering, 'ascend'];
            }
        }
        const newCols: ColumnsType<T> = [...columns];
        if (orderField) {
            const sortedColumnIndex = columns.findIndex(col => {
                if (typeof col.key === 'string') {
                    return col.key.split('.').at(-1) === orderField; 
                }
                return false;
            })

            if (sortedColumnIndex !== -1) {
                // Clear current sort order
                newCols.forEach(col => delete col['defaultSortOrder']);
                newCols.forEach(col => delete col['sortOrder']);
                newCols[sortedColumnIndex].sortOrder=orderDirection;
                return newCols;
            }
        } else {
            newCols.forEach(col => delete col['sortOrder']);
        }
        return columns;
    }, [filterPrefix, searchParams, columns]);

    const setOrder = useCallback((field: SorterResult<Model>['field'], direction: SortOrder | undefined) => {
        // Handle nested dataIndex
        let fieldForQuery = Array.isArray(field) ? field.at(-1) : field;
        const searchParamName = `${filterPrefix}.ordering`;

        if(direction) {
            const order = direction === 'ascend' ? '' : '-';
            searchParams.set(searchParamName, order + fieldForQuery);
        }
        else {
            searchParams.delete(searchParamName)
        }
        setSearchParams(searchParams);

    }, [searchParams, filterPrefix, setSearchParams]);
    
    return {columnsWithOrder, setOrder};
}